import { render, staticRenderFns } from "./CreateContactInputs.vue?vue&type=template&id=724c10a5&scoped=true"
import script from "./CreateContactInputs.vue?vue&type=script&lang=js"
export * from "./CreateContactInputs.vue?vue&type=script&lang=js"
import style0 from "./CreateContactInputs.vue?vue&type=style&index=0&id=724c10a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724c10a5",
  null
  
)

export default component.exports